import { render, staticRenderFns } from "./MerchantCompanyInformationPage.vue?vue&type=template&id=24907418"
import script from "./MerchantCompanyInformationPage.vue?vue&type=script&lang=js"
export * from "./MerchantCompanyInformationPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports